<template>
  <div class="mod-verification">
    <a-layout class="layout" >
      <a-space direction="vertical" size="middle">
        <div :style="{textAlign: 'center', backgroundColor: '#fff'}">
          <h3>需要验证您的身份</h3>
          <p v-if="options.length > 0">为了保障您的账户安全，需核实是否账户所有人操作，注销账户需要发送验证码至账户绑定手机号或者邮箱进行安全核验。</p>
          <p v-else>此账户未绑定手机号或邮箱，无法接收验证码。为保障您的账号安全，请绑定手机号或邮箱后再进行注销。</p>
        </div>
        <div v-if="options.length > 0">
          <a-form
            class="mod-form"
            layout="horizontal"
            labelAlign="left"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            :colon="false"
            :form="checkOtherForm"
          >
            <a-form-item label="验证方式" >
              <a-select size="large" v-model="type" :options="options">
              </a-select>
              <span slot="help" v-if="!options.length">您未预留有效的手机号、邮箱、安全问题！如需要找回密码，请通过实名认证重新设置密码。</span>
            </a-form-item>
            <a-form-item label="手机号码" v-if="type === 'mobile'">
              <a-input
                size="large"
                v-model="phone"
                read-only
              >
                <span slot="addonBefore">{{ areaCodeText }}</span>
              </a-input>
            </a-form-item>
            <a-form-item label="邮箱" v-if="type === 'email'">
              <a-input
                size="large"
                v-model="email"
                read-only
              >
              </a-input>
            </a-form-item>
            <a-form-item label="验证码">
              <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
              </user-slider-captcha>
            </a-form-item>
            <a-form-item label="手机验证码" v-if="type === 'mobile'">
              <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="15" :areaCode="areaCode" :value="phone" :token="token" @change="onVerificationCodeChange">
              </user-verification-code>
            </a-form-item>
            <a-form-item label="邮箱验证码" v-if="type === 'email'">
              <user-verification-code placeholder="请输入邮箱动态码" size="large" type="email" actionText="获取邮箱动态码" :smsType="15" :value="email" :token="token" @change="onVerificationCodeChange">
              </user-verification-code>
            </a-form-item>
          </a-form>
        </div>
        <div v-if="options.length > 0" class="action" :style="{textAlign: 'center', backgroundColor: '#fff'}">
          <div class="action">
            <a-button size="large" @click="onCancel">返回</a-button>
            <a-button size="large" type="primary" @click="onCheckOther" :loading="loading">开始校验</a-button>
          </div>
          <div class="mod-tip" v-if="verificationTip" :style="{ textAlign: 'left', marginTop: '20px' }">
            <h4>温馨提示：</h4>
            <p>{{ verificationTip }}</p>
          </div>
        </div>
        <div v-if="options.length === 0">
          <div class="action">
            <a-button size="large" type="primary" @click="onGoBinding('mobile')">绑定手机</a-button>
            <a-button size="large" type="primary" @click="onGoBinding('email')">绑定邮箱</a-button>
          </div>
          <div class="mod-tip" v-if="bindingTip" :style="{ textAlign: 'left', marginTop: '20px' }">
            <h4>温馨提示：</h4>
            <p>{{ bindingTip }}</p>
          </div>
        </div>
      </a-space>
    </a-layout>
    <a-modal
      v-model="visibleCheckPopup"
      wrapClassName="deregistration-verification-modal"
      title="会员身份验证"
      ok-text="确认"
      cancel-text="返回"
      :closable="false"
      :maskClosable="false"
      @ok="onCheckPassword"
      @cancel="onCancel"
    >
      <p>请输入与本账号关联的{{ app.sortName }}会员登录密码</p>
      <a-form
        class="mod-form"
        :form="checkPasswordForm"
      >
        <a-form-item>
          <a-input
            size="large"
            placeholder="请输入密码"
            type="password"
            v-decorator="[
              'checkPassword',
              {
                rules: [
                  { validator: handleFieldValidate }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model="visibleCancelPopup"
      wrapClassName="deregistration-verification-modal"
      title="会员注销账号"
      ok-text="确认"
      cancel-text="返回"
      :closable="false"
      :maskClosable="false"
      @ok="onDeregistration"
      @cancel="onHideCancelPopup"
    >
      <p>安全审核通过，即将申请注销账号！</p>
    </a-modal>
  </div>
</template>

<script>
import { validate } from '@/utils/validate'
import areaCodeOptions from '@/utils/areacode'
import { checkKey, cancel } from '@/api/member'
import eventBus from '@/components/eventBus.js'
import queryString from 'query-string'

export default {
  props: {
    userInfo: Object,
    verificationTip: String,
    bindingTip: String,
    app: Object
  },
  data () {
    return {
      visibleCheckPopup: false,
      visibleCancelPopup: false,
      userPassword: '',
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      checkOtherForm: this.$form.createForm(this),
      checkPasswordForm: this.$form.createForm(this),
      loading: false,
      options: [],
      type: '',
      token: '',
      code: '',
      errCode: '',
      checkPasswordResult: {},
      checkOtherResult: {},
      userCenterType: '',
      phone: '',
      areaCode: '',
      email: ''
    }
  },
  created () {
    const { userInfo } = this
    ;[this.phone, this.email, this.areaCode, this.userCenterType] = [userInfo.phone, userInfo.email, userInfo.areaCode, userInfo.userCenterType]
    const options = []

    if (this.email && userInfo.emailStatus === 0) {
      options.push({
        label: '邮箱',
        value: 'email'
      })
      this.type = 'email'
    }

    if (this.phone && userInfo.phoneStatus === 0) {
      options.push({
        label: '手机号码',
        value: 'mobile'
      })
      this.type = 'mobile'
    }

    this.options = options

    if (this.userCenterType !== 1) {
      this.visibleCheckPopup = true
    }

    eventBus.$on('get-token', (value) => {
      this.onGetFinalToken(value)
    })
  },
  computed: {
    areaCodeText () {
      const value = find(areaCodeOptions, { value: this.areaCode })
      return value ? value.title : '中国+86'
    }
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate('deregistration', this.checkPasswordForm.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onCancel () {
      this.$emit('goBack')
    },
    onHideCancelPopup () {
      this.visibleCancelPopup = false
    },
    onGoBinding (type) {
      const params = queryString.parse((location.search), { decode: false })
      const extraParams = {
        channel: params.channel,
        source: params.source
      }

      this.$router.push({
        path: '/binding',
        query: {
          action: 'bind',
          type,
          ...extraParams
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
      if (this.errCode.toString().includes(1000)) {
        this.finalToken = value
      }
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onGetFinalToken (value) {
      this.finalToken = value
      this.errCode = ''
    },
    async onCheckPassword () {
      this.checkPasswordForm.validateFields(async (errors, values) => {
        if (!errors) {
          const params = {
            callType: 1, // 请求类型：1.用户注销
            checkType: 10, // 校验类型：10.密码 20.验证码验证
            key: values.checkPassword
          }
          try {
            const result = await checkKey(params)
            this.checkPasswordResult = result
            this.$message.success('验证成功！')
            this.visibleCheckPopup = false
          } catch (err) {
            this.$message.error(err.message)
          }
        }
      })
    },
    async onCheckOther (e) {
      e.preventDefault()
      const { checkPasswordResult } = this
      this.checkOtherForm.validateFields(async (errors, values) => {
        if (!errors) {
          const { token, finalToken, code, phone, email, areaCode, type, userCenterType } = this
          if (!code) {
            this.$error({
              content: `请输入${type === 'mobile' ? '手机' : '邮箱'}动态码！`,
              centered: true
            })
            return
          }
          if (!token) {
            this.$error({
              content: '请拖动滑块完成验证！',
              centered: true
            })
            return
          }
          if (!finalToken) {
            this.$error({
              content: '请点击获取动态码！',
              centered: true
            })
            return
          }
          const params = {
            callback: 1, // 请求类型：1.用户注销
            checkType: 20, // 校验类型：10.密码 20.验证码验证
            valueType: type === 'mobile' ? 0 : 1, // 校验类型 0.手机 1.邮箱
            key: code,
            value: type === 'mobile' ? phone : email,
            areaCode: areaCode
          }
          if (userCenterType !== 1) {
            params.token = checkPasswordResult.token
          }
          this.loading = true
          try {
            const result = await checkKey(params)
            this.checkOtherResult = result
            this.$message.success('验证成功！')
            this.loading = false
            this.visibleCancelPopup = true
          } catch (err) {
            this.$message.error(err.message)
            this.loading = false
            this.$refs.verify.refresh()
            if (err.code.toString().includes(1000)) {
              this.errCode = err.code
            }
          }
        }
      })
    },
    async onDeregistration () {
      const { checkOtherResult } = this
      const params = {
        token: checkOtherResult.token
      }
      try {
        await cancel(params)
        this.$emit('goSuccess')
      } catch (err) {
        this.$message.error(err.message)
      }
    }
  }
}
</script>
